var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWinning = function SvgIconWinning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#FFEAE1",
    rx: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-winning_svg__a)",
    d: "M30.14 9.39a2.92 2.92 0 0 0-2.006.813 10 10 0 0 0-.269-1.862.45.45 0 0 0-.165-.245.48.48 0 0 0-.285-.096l-12.513.004c-2.66 0-2.776 0-2.78.395a9.3 9.3 0 0 0-.26 1.8 2.9 2.9 0 0 0-1.463-.74 2.95 2.95 0 0 0-1.64.164c-.519.21-.962.561-1.275 1.012A2.7 2.7 0 0 0 7 12.16v1.104a5.7 5.7 0 0 0 1.683 4.05 6.1 6.1 0 0 0 4.13 1.765h1.555c.418.57.892 1.101 1.416 1.584A6.5 6.5 0 0 1 17.674 24h4.657a6.43 6.43 0 0 1 1.936-3.392q.751-.706 1.36-1.53h1.574a6.1 6.1 0 0 0 4.121-1.77A5.7 5.7 0 0 0 33 13.263v-1.104c0-.733-.301-1.437-.838-1.956a2.92 2.92 0 0 0-2.022-.812m-17.309 8.79a5.15 5.15 0 0 1-3.483-1.497 4.82 4.82 0 0 1-1.42-3.42v-1.104c0-.37.113-.73.325-1.038a1.9 1.9 0 0 1 .867-.69c.353-.141.742-.179 1.117-.107.376.071.72.249.991.51.27.261.455.594.53.956a1.8 1.8 0 0 1-.108 1.08 1.9 1.9 0 0 1-.711.84 2 2 0 0 1-1.074.316.47.47 0 0 0-.324.134.44.44 0 0 0 0 .63.47.47 0 0 0 .324.133c.437 0 .869-.098 1.26-.286.393-.187.735-.46 1-.795q.184.92.484 1.813c.3.879.693 1.725 1.174 2.526zm10.391-3.988-.924.875.218 1.234a.9.9 0 0 1-.057.496.9.9 0 0 1-.32.393.97.97 0 0 1-.992.07L20 16.678l-1.147.584a.97.97 0 0 1-.992-.071.9.9 0 0 1-.32-.393.9.9 0 0 1-.057-.496l.218-1.234-.924-.875a.889.889 0 0 1-.234-.933.9.9 0 0 1 .286-.415.97.97 0 0 1 .468-.21l1.281-.179.576-1.121a.93.93 0 0 1 .35-.366.97.97 0 0 1 .99 0c.15.089.27.215.35.366l.576 1.121 1.281.18c.173.027.335.099.468.21a.889.889 0 0 1 .052 1.348m8.85-.929c-.009 3.091-2.746 5.212-5.841 4.917a13.5 13.5 0 0 0 1.648-4.33c.266.334.608.604 1 .79.39.186.82.283 1.256.283a.47.47 0 0 0 .329-.131.44.44 0 0 0 0-.635.47.47 0 0 0-.329-.131c-.382 0-.756-.11-1.074-.316a1.9 1.9 0 0 1-.71-.84 1.8 1.8 0 0 1-.11-1.08c.076-.362.26-.695.531-.956.27-.261.616-.439.99-.51a2 2 0 0 1 1.118.107c.353.142.655.382.867.69s.325.669.324 1.038z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-winning_svg__b)",
    d: "M20.807 13.411 20.01 12l-.829 1.411a.5.5 0 0 1-.165.173.6.6 0 0 1-.24.083L17 13.894l1.278 1.122a.5.5 0 0 1 .135.194.4.4 0 0 1 .017.227l-.304 1.544a16 16 0 0 1 1.869-.767c.156-.05 1.675.734 1.84.786l-.275-1.562a.4.4 0 0 1 .016-.228.5.5 0 0 1 .135-.194L23 13.922l-1.787-.255a.6.6 0 0 1-.24-.083.5.5 0 0 1-.166-.173"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-winning_svg__c)",
    d: "M26.512 31.067h-1.086v-2.1H17.88a.5.5 0 0 1-.346-.14.45.45 0 0 1-.142-.327c0-.123.05-.24.142-.328a.5.5 0 0 1 .346-.139h7.547v-1.166c0-.245-.05-.488-.15-.715a1.9 1.9 0 0 0-.43-.605 2 2 0 0 0-.643-.405 2.1 2.1 0 0 0-.759-.142h-6.888c-.26 0-.518.048-.759.142-.24.094-.459.231-.643.405-.184.173-.33.379-.43.605-.1.227-.15.47-.15.715v4.2h-1.086a.5.5 0 0 0-.345.139.45.45 0 0 0-.143.327c0 .123.051.24.143.328a.5.5 0 0 0 .345.139h13.024a.5.5 0 0 0 .345-.14.45.45 0 0 0 .143-.327.45.45 0 0 0-.143-.327.5.5 0 0 0-.345-.14"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-winning_svg__a",
    x1: 17.305,
    x2: 19.53,
    y1: 13.559,
    y2: 27.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD263"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-winning_svg__b",
    x1: 19.378,
    x2: 20.301,
    y1: 13.737,
    y2: 18.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD263"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-winning_svg__c",
    x1: 18.549,
    x2: 19.346,
    y1: 27.432,
    y2: 33.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD263"
  })))));
};
export default SvgIconWinning;